import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    Container,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';


import moment from 'moment';
import DateNavigation from './dateNavigation';
import CalendarEventComponent from './calendarEventComponent';
import CustomCalendar from './customCalendar';
import CustomFilterCalendar from './customFilterCalendar';
import Page from '../../containers/page';
import { API_ENDPOINT } from '../../constants';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { v4 as uuidv4 } from 'uuid';
import UpdateEventModal from './updateEventModal';
import ErrorModal from '../../components/errorModal';
import ScheduleEventModal from './scheduleEventModal';
import ScheduleSlot from './scheduleEventHelper/scheduleSlot';


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


class MultiCalendar extends React.Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();

        this.state = {
            filter: {
                clinicians: [],
                professions: [],
                eventTypes: []
            },
            events: [],
            legendData: [],
            updatedEvents: [],
            webBookingFormsDict: {}

        }
    }

    setInitialData = () => {
        this.fetchItems();
        this.prepareLegendData();

        this.getWebBookingForms();
    }
    getWebBookingForms = () => {
        let data = {
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic
        }

        fetch(API_ENDPOINT + `/data/calendar/webbooking-forms/fetch`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(parseJSON).then(({ result, status }) => {
            let webBookingFormsDict = {};
            if (result?.length) {
                result.forEach(form => {
                    if (form?._id) {
                        webBookingFormsDict[form._id] = form;
                    }
                });
            }
            this.setState({ webBookingFormsDict });
        }).catch(err => {
            console.log(err);
        })
    }
    prepareLegendData = () => {
        let legendData = [
            { name: 'Event'.translate(this.props.lang), color: '#dbd233' },
            { name: 'Visit by referral'.translate(this.props.lang), color: '#568ac8' },
            { name: 'All online visits'.translate(this.props.lang), color: '#3a3f56' },
            { name: 'Visit without referral'.translate(this.props.lang), color: '#60bebb' },
            { name: 'Available for online booking'.translate(this.props.lang), color: 'green' },
            { name: 'Assisting to other caregiver'.translate(this.props.lang), color: '#fdab94' },
            { name: 'Administrative booking'.translate(this.props.lang), color: '#808080' },
            { name: 'All Web booking events'.translate(this.props.lang), color: '#B256C8' },
            { name: 'Booked in another clinic/department'.translate(this.props.lang), color: 'rgba(86, 138, 200, 0.5)' }
        ];
        if (this.props.hasTakeCare) {
            legendData.push({ name: 'Event in Take Care Calendar'.translate(this.props.lang), color: '#E30B5C' });
        }
        if (this.props.hasSemble) {
            legendData.push({ name: 'Event from Semble'.translate(this.props.lang), color: '#E30B5C' });
            legendData.push({ name: 'Online event from Semble'.translate(this.props.lang), color: '#B20A4F' })
            legendData.push({ name: 'Event from Semble in other department'.translate(this.props.lang), color: 'rgba(227, 11, 92, 0.5)' });
        }


        this.setState({ legendData });
    }


    componentDidMount() {
        this.setInitialData();

        if (this.getFiltersFromLocalStorage) {
            this.getFiltersFromLocalStorage();
        }

        this.socketInitialize();
    }
    socketInitialize = () => {
        if (this.props.uData && this.props.socket && !this.state._registerEvents) {
            this.setState({
                _registerEvents: true
            }, () => {
                this.registerEvents();


            })
        } else {
            this.socketInterval = setInterval(() => {
                if (this.props.uData && this.props.socket && !this.state._registerEvents) {
                    if (this.socketInterval) {
                        clearInterval(this.socketInterval)
                    }

                    this.setState({
                        _registerEvents: true
                    }, () => {
                        this.registerEvents();


                    })
                }

            }, 150);
        }
    }
    registerEvents = async () => {

        this.props.socket.on('newEventCreated', (data) => {
            this.fetchItems(true);
            setTimeout(() => {
                this.fetchItems(true);
            }, 300);
        })

    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedGroup !== this.props.selectedGroup || prevProps.selectedClinic !== this.props.selectedClinic) {
            this.resetPage();
        }

    }
    resetPage = () => {
        // to={{ pathname: to == currentPathname && !this.props.refershPageDisabled ? '/refresh/page' : to, state: { reditectTo: to == currentPathname && !this.props.refershPageDisabled? to : null } }}
        const pathname = this.props[0].location.pathname;
        const refreshPathname = '/refresh/page';
        const stateObj = {
            reditectTo: pathname
        }
        if (pathname) {
            this.props[0].history.push(refreshPathname, stateObj);
        }
    }
    componentWillUnmount() {
        if (this.props.socket) {
            this.props.socket.removeListener('newEventCreated');
        }

    }

    saveFiltersToLocalStorage = (clinicians, professions, eventTypes) => {
        const clinicId = this.props.selectedClinic;
        if (!clinicians || !professions || !clinicId || typeof window === 'undefined') return;

        let calendarFilters = localStorage?.calendarFilters ? JSON.parse(localStorage?.calendarFilters) : {};
        calendarFilters[clinicId] = {
            clinicians: [...clinicians],
            professions: [...professions],
            eventTypes: [...eventTypes]
        };
        let stringifyData = JSON.stringify(calendarFilters);
        if (localStorage?.calendarFilters !== stringifyData) {
            localStorage.setItem('calendarFilters', stringifyData);
        }
    }

    updateEventIsDone = (isDone, id, doctor) => {
        console.log('isDone', isDone, 'id', id, 'doctor', doctor);

        fetch(API_ENDPOINT + `/working-hours/event/update-is-done/` + id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ isDone: isDone, doctor: doctor })
        }).then(res => res.json()).then((result) => {

            this.fetchItems();
        })

    }

    fetchItems = (fastReload = false) => {
        const filter = this.state.filter;
        if (!filter) return;

        const clinicians = filter?.clinicians ?? [];
        const professions = filter?.professions ?? [];
        const eventTypes = filter?.eventTypes ?? [];

        const calendarConfig = this.state.calendarConfig;
        if (!calendarConfig?.date || !calendarConfig?.view) return;

        if (clinicians.length === 0) {
            this.setState({ events: [] })
            return;
        }
        let data = {
            clinicians,
            professions,
            eventTypes,
            calendarConfig,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
        }

        this.saveFiltersToLocalStorage(clinicians, professions, eventTypes);

        if (fastReload) { // without user showing loading animation
            let fetchKey = uuidv4();
            this.fetchKey = fetchKey;
            data.fetchKey = fetchKey;
            fetch(API_ENDPOINT + `/data/calendar/events/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.events?.length && this.fetchKey === result?.fetchKey) {
                    this.setState({ events: result.events })
                }
            }).catch(err => {
                console.log(err);
            })
        } else {
            this.setState({ events: [], loadingEvents: true }, () => {
                let fetchKey = uuidv4();
                this.fetchKey = fetchKey;
                data.fetchKey = fetchKey;
                fetch(API_ENDPOINT + `/data/calendar/events/fetch`, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                }).then(parseJSON).then(({ result, status }) => {
                    if (result?.events?.length && this.fetchKey === result?.fetchKey) {
                        this.setState({ events: result.events, loadingEvents: false })
                    } else {
                        this.setState({ loadingEvents: false })
                    }
                }).catch(err => {
                    console.log(err);
                    this.setState({ loadingEvents: false })
                })
            })
        }



    }
    getReferralData = async (eventId) => {
        if (!eventId) return null;

        let result = await fetch(API_ENDPOINT + `/data/calendar/referral-data/event/${eventId}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(parseJSON).then(({ result, status }) => {
            return result;
        }).catch(err => {
            console.log(err);
            return null;
        })
        let response = await result;

        if (response?.referral) {
            return response.referral;
        } else {
            return null;
        }
    }
    onChangeEvent = async (oldItem, newItem, callback) => {

        // console.log('onChangeEvent', oldItem, newItem)
        if (!oldItem || !newItem) {
            if (this.cancelLayoutElementChange) this.cancelLayoutElementChange?.();
            return;
        }
        // console.log('oldItem', oldItem)
        // console.log('newItem', newItem)
        if (
            oldItem?.data?.doctorId === newItem?.data?.doctorId
            && oldItem?.data?.startTime === newItem?.data?.startTime
            && oldItem?.data?.endTime === newItem?.data?.endTime
        ) {
            if (this.cancelLayoutElementChange) this.cancelLayoutElementChange?.();
            return;
        }

        const eventId = oldItem.i === newItem.i ? oldItem.i : null;
        if (!eventId) {
            if (this.cancelLayoutElementChange) this.cancelLayoutElementChange?.();
            return;
        }

        const doctorId = oldItem?.data?.doctorId;
        if (!doctorId) {
            if (this.cancelLayoutElementChange) this.cancelLayoutElementChange?.();
            return;
        }

        let event = this.state.events?.find(item => item._id === doctorId)?.events?.find(item => item._id === eventId);
        if (!event) {
            event = this.state.clipboard?.find(item => item._id === eventId);
        }
        if (!event) {
            if (this.cancelLayoutElementChange) this.cancelLayoutElementChange?.();
            return;
        }

        const type = event.type;
        if (type === 'referral' || type === 'revisit') {
            let referralData = await this.getReferralData(event?._id);
            if (referralData) {
                event.referralData = referralData;
            }
        }
        // console.log('event', event)
        let updateEventData = {
            event,
            oldItem,
            newItem,
            callback
        }
        this.setState({ updateEventData })

    }
    render() {
        if (typeof window === 'undefined') {
            return;
        }
        if (window.innerWidth < 768) {
            return (
                <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                    <p style={{ textAlign: 'center', fontWeight: 600, marginTop: 50 }}>
                        {"Please use a desktop device to access this page.".translate(this.props.lang)}
                    </p>
                </div>
            )
        }

        const scheduleEventEnabled = true;

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel'>
                                <div className="component-header-wrap">
                                    <h5 className="component-header">
                                        {this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}
                                    </h5>
                                    {
                                        scheduleEventEnabled ?
                                            <div className="component-header-actions">
                                                <Button
                                                    color="primary"
                                                    onClick={() => {
                                                        this.setState({ scheduleEvent: !this.state.scheduleEvent })
                                                    }}>
                                                    {'Schedule event/appointment'.translate(this.props.lang)}
                                                </Button>
                                            </div>
                                            :
                                            null
                                    }

                                </div>

                                <div className='multi-calendar-wrap'>

                                    {
                                        this.state.loadingEvents ?
                                            <div className="export-loader-wrap">
                                                <div className="loader-wrap">
                                                    <Player
                                                        autoplay={true}
                                                        loop={true}
                                                        renderer={'svg'}
                                                        src="/lf30_editor_l5cxzdyf.json"
                                                        style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                                    ></Player>

                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                    <CustomCalendar
                                        {...this.props}
                                        items={this.state.events?.length ? this.state.events : []}
                                        webBookingFormsDict={this.state.webBookingFormsDict}
                                        onChangeDate={(date, view) => {
                                            this.setState({
                                                calendarConfig: {
                                                    date,
                                                    view
                                                }
                                            }, () => {
                                                this.fetchItems();
                                            })
                                        }}
                                        onChangeEvent={(oldItem, newItem, callback) => {
                                            this.onChangeEvent(oldItem, newItem, callback);
                                        }}
                                        updateEventIsDone={(isDone, id, doctor) => {
                                            this.updateEventIsDone(isDone, id, doctor);
                                        }}
                                        updatedEvents={this.state.updatedEvents}
                                        addToUpdatedEvents={(eventIds) => {
                                            let updatedEvents = this.state.updatedEvents ?? [];
                                            if (eventIds?.length) {
                                                eventIds.forEach(eventId => {
                                                    if (!updatedEvents.includes(eventId)) {
                                                        updatedEvents.push(eventId);
                                                    }
                                                })
                                                this.setState({ updatedEvents })

                                            }
                                        }}
                                        registerScrollToInitialBlock={(scrollToInitialBlock) => this.scrollToInitialBlock = scrollToInitialBlock}
                                        registerCancelLayoutElementChange={(cancelLayoutElementChange) => this.cancelLayoutElementChange = cancelLayoutElementChange}
                                        fetchItems={() => this.fetchItems()}
                                        customFilters={[
                                            <CustomFilterCalendar
                                                {...this.props}
                                                onChange={(data) => {
                                                    let filter = {
                                                        clinicians: [...data.clinicians],
                                                        professions: [...data.professions],
                                                        eventTypes: [...data.eventTypes]
                                                    }
                                                    let changesExists = false;
                                                    if (JSON.stringify(filter) !== JSON.stringify(this.state.filter)) {
                                                        changesExists = true;
                                                    } else if (filter.clinicians.length !== this.state.filter.clinicians.length) {
                                                        changesExists = true;
                                                    } else if (filter.professions.length !== this.state.filter.professions.length) {
                                                        changesExists = true;
                                                    } else if (filter.eventTypes.length !== this.state.filter.eventTypes.length) {
                                                        changesExists = true;
                                                    }

                                                    if (changesExists) {
                                                        this.setState({
                                                            filter
                                                        }, () => {
                                                            this.fetchItems();
                                                        })
                                                    }

                                                }}
                                                getFiltersFromLocalStorage={(getFiltersFromLocalStorage) => this.getFiltersFromLocalStorage = getFiltersFromLocalStorage}
                                            />
                                        ]}
                                        legendData={this.state.legendData}
                                        setClipboardData={(data) => {
                                            this.setState({ clipboard: data })
                                        }}
                                    />
                                </div>

                            </div>

                        </Col>
                    </Row>
                </Container>

                {
                    this.state.updateEventData ?
                        <UpdateEventModal
                            {...this.props}
                            isOpen={this.state.updateEventData}
                            onError={(error) => {
                                if (error) {
                                    this.setState({ error })
                                }
                            }}
                            onSuccessUpdate={(eventId) => {
                                let updatedEvents = this.state.updatedEvents ?? [];
                                if (!updatedEvents.includes(eventId)) {
                                    updatedEvents.push(eventId);
                                }
                                this.setState({ updatedEvents })
                                if (this.state.updateEventData?.callback) {
                                    this.state.updateEventData.callback();
                                }
                            }}
                            toggle={(callback = null) => {
                                this.setState({ updateEventData: null }, () => {
                                    if (callback) callback?.();
                                    this.fetchItems();
                                })
                            }}
                        />
                        :
                        null
                }
                {/* {
                    this.state.scheduleEvent ?
                        <ScheduleSlot
                            {...this.props}
                            isOpen={this.state.scheduleEvent}
                            toggle={(callback = null) => {
                                this.setState({ scheduleEvent: null }, () => {
                                    if (callback) callback?.();
                                    this.fetchItems();
                                })
                            }}
                        />
                        :
                        null
                } */}
                {
                    this.state.scheduleEvent ?
                        <ScheduleEventModal
                            {...this.props}
                            isOpen={this.state.scheduleEvent}
                            toggle={(notFetchItems = false, callback = null) => {
                                this.setState({ scheduleEvent: null }, () => {
                                    if (callback) callback?.();
                                    if (!notFetchItems)
                                        this.fetchItems();
                                })
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                            closeButtonText={'Cancel'.translate(this.props.lang)}
                        >
                            {this.state.error}
                        </ErrorModal>
                        :
                        null
                }

            </div>


        )
    }
}

export default Page(MultiCalendar);